import { Component, Input } from '@angular/core';

import { Configuration } from '../../conf/app.constants';
import { TenderingBaseComponent } from './tenderingBase.component';
import {
  ProcurementProjectDTO,
  ProcurementProjectLotDTO,
  CriteriaDTO,
  ProjectEntityDTO
} from '../../api/plyca-dtos-v2';
import { FormAction } from '../../components/forms/form.objects';

import { Observable } from 'rxjs';
import { PlycaDataService } from '../../../services/plyca.service';
import { ChildOfProjectDTO } from '../../api/plyca-dtos';
import { awardCriteriaFormulasComponent } from '../awardCriteriaFormulas/awardCriteriaFormulas.component';
import { HelpType } from '../../components/common/help/help.service';
import { TreeNode } from 'primeng-lts/api';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'tenderingAwardCriteria',
  templateUrl: 'tenderingAwardCriteria.template.html'
})
export class TenderingAwardCriteriaComponent extends TenderingBaseComponent<
  ProcurementProjectLotDTO
> {

  @Input()
  private projectAwardCriterias: Array<ProcurementProjectLotDTO>;
  groupedInfo: Array<TreeNode>;

  beanToDTO(lote: any): ProcurementProjectLotDTO {
    delete lote.selectionAwardCriteria;
    lote.selectionAwardCriteria = new Array<CriteriaDTO>();
    lote.selectionAwardCriteria.push(lote['editingCriteria']);

    lote.project = {} as ProjectEntityDTO;
    lote.project.identifier = lote['editingProjectIdentifier'];

    delete lote['editingCriteria'];
    delete lote['editingProjectIdentifier'];

    return lote;
  }

  createBean(
    criteria: CriteriaDTO,
    lote: ProcurementProjectLotDTO
  ): ProcurementProjectLotDTO {
    lote['editingCriteria'] = criteria;
    lote['editingProjectIdentifier'] = this.project.identifier;
    // criteria.lote=lote;

    return lote;
  }

  dtoToBean(dto: ProcurementProjectLotDTO) {
    return dto as any;
  }

  constructor(private configuration: Configuration,
    private translateService: TranslateService) {
    super();

    this.colHeaders = [
      'ProcurementProjectLot.id',
      'AwardCriteria.name',
      'AwardCriteria.weight',
      'AwardCriteria.features',
      'AwardCriteria.formula',
      /*'AwardCriteria.transferPriceOffer.titletable',*/
      'General.actions'
    ];

  }

  ngAfterContentInit(): void {
    this.loadAwardCriteria();
  }

  loadAwardCriteria() {
    this.projectAwardCriterias = [];
    this.subscribe(this.plycaService
      .get<ProcurementProjectDTO>(
        this.configuration.PROCUREMENTPROJ_SERVICE_URL,
        this.project.identifier,
        this.getloadAwardCriteriaParams()
      ),
      (value: any) => {
        if (value.breakdownLot.apportioned) {
          this.projectAwardCriterias = value.breakdownLot.lots;
        } else {
          this.projectAwardCriterias.push(value.breakdownLot.totalLots);
        }

        this.loaded = true;
      });
  }

  getloadAwardCriteriaParams() {
    return {
      expand: 'expansionSet:AWARDCRITERIA'
    };
  }

  getTagsIdentifier(): string[] {
    return [HelpType.EDIT_FORMULA_CRIT];
  }


  getServiceURL(): string {
    return (
      this.configuration.PROCUREMENTPROJ_SERVICE_URL +
      this.project.identifier +
      '/contexts/awardcriteria/procurementProjectsLots'
    );
  }
  getValidationCtx(): string {
    return '';
  }
  getFormSettingURL(): string {
    return 'tenderingAwardCriteriaSettings.json';
  }
  getDialogTitle(): string {
    return 'AwardCriteria.edit.title';
  }
  executeFormAction(model: any): Observable<any> {
    return this.plycaService.patch<any>(this.getServiceURL(), model);
  }
  emitUpdate(identifier: any, updatedData?: any): void {
    this.loadAwardCriteria();
  }
  getActionForm(): FormAction<any> {
    return new TenderingAwardCriteriaAction<any>(
      this.plycaService,
      this.getServiceURL(),
      this.getValidationCtx(),
      this.beanToDTO,
      'General.save',
      'btn btn-primary',
      'fa fa-save',
      'aceptar'
    );



  }


  /*setDumpPrice(option: string, criteria: any) {
    criteria.transferPriceOffer = option;
    console.log(criteria.transferPriceOffer);
  }

  getDumpPriceOptionLabel(option: string): string {
    switch (option) {
      case 'NO':
        return this.translateService.instant('AwardCriteria.transferPriceOffer.no');
      case 'PRE':
        return this.translateService.instant('AwardCriteria.transferPriceOffer.pretable');
      case 'PREU':
        return this.translateService.instant('AwardCriteria.transferPriceOffer.preutable');
      default:
        return '';
    }
  }*/

  openFormulas(comp: any): void {
    const config: DynamicDialogConfig = {
      header: this.translationService.instant('AwardCriteria.adm'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition',
      closable: true,
      closeOnEscape: true,
      baseZIndex: 1500
    };

    const refDialog = this.dialogService.open(
      awardCriteriaFormulasComponent,
      config
    );

    /*
 let context = new MessageDTOModal(message, titleKey);
  //messageData: string | I18nData, titleKey?: string | I18nData) {
    //let config: any = ServiceLocator.injector.get(DynamicDialogConfig);
      let config: DynamicDialogConfig = {
          header: context.title,
          width: '70%',
          style: { overflow: 'scroll' },
          styleClass: styleClass
        };
        config['context'] = context;

        let ref = this.dialogService.open(messageComponent, config);

*/
  }
}
export class TenderingAwardCriteriaAction<T extends ChildOfProjectDTO<any>>
  implements FormAction<any> {
  actionId: string;
  buttonTextKey: string;
  buttonClass: string;
  imageClass: string;
  closeOnSuccess = true;
  visibility = true;
  constructor(
    private plycaService: PlycaDataService,
    private url: string,
    private validationCtx: string,
    private transformationFunc: Function,
    buttonTextKey: string,
    buttonClass: string,
    imageClass: string,
    actionId: string
  ) {
    this.buttonTextKey = buttonTextKey;
    this.buttonClass = buttonClass;
    this.imageClass = imageClass;
    this.actionId = actionId;
  }
  executeFormAction(model: any): Observable<any> {
    return this.plycaService.patch<any>(this.url, model);
  }
}
